'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _CwLog = require('../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

var _IntlService = require('../services/IntlService');

var _Locale = require('../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Decorated result body of a fetch response
 * @param {string} url 
 * @param {number} status 
 * @param {any} response 
 * @param {string} error 
 * @param {string[]} errorMessages 
 */
var getResult = function getResult(url, status, response) {
  var error = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var errorMessages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var headers = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

  return {
    isSuccess: !error,
    status: status,
    response: response,
    error: error,
    errorMessages: errorMessages,
    headers: headers
  };
};

/**
 * Handles any unexpected error by returning default error message
 * @param {string} url
 * @param {Object} e 
 */
var handleUnexpectedError = function handleUnexpectedError(url, status, e) {
  var errorMsg = e.message ? e.message : "Unhandled Error";
  _CwLog2.default.error("Request Failed.\nUrl: " + url + "\nMessage: " + errorMsg);

  return getResult(url, status, undefined, errorMsg);
};

/**
 * Default error handler
 * @param {string} url
 * @param {Object} e 
 */
var defaultHandler = function defaultHandler(url, status, e) {
  try {
    return e.json().then(function (json) {
      var message = json.message || (0, _stringify2.default)(json);

      var hasErrorMessages = json.errors && json.errors.length > 0;

      var errorMessages = hasErrorMessages ? json.errors.map(function (err) {
        return err.message;
      }) : [];

      return getResult(url, status, undefined, message, errorMessages);
    }).catch(function () {
      return handleUnexpectedError(url, status, e);
    });
  } catch (ex) {
    return handleUnexpectedError(url, status, e);
  }
};

var getError = function getError(url, e) {
  var status = e.status;

  switch (status) {
    case 401:
      // Unauthenticated
      return getResult(url, status, undefined, (0, _IntlService.formatMessage)(_Locale2.default.unauthorized));

    case 404:
      // Record not found
      return getResult(url, status, undefined, (0, _IntlService.formatMessage)(_Locale2.default.not_found));

    case 409:
      // Conflict
      return getResult(url, status, undefined, (0, _IntlService.formatMessage)(_Locale2.default.conflict));

    default:
      return defaultHandler(url, status, e);
  }
};

var apiFetch = function apiFetch(url, options) {
  var isJson = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return fetch(url, options).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response;
  }).then(function (response) {
    return new _promise2.default(function (resolve) {
      var status = response.status;
      var result = status === 204 ? undefined : isJson ? response.json() : response.blob(); // handle empty body resonse

      _promise2.default.resolve(result).then(function (result) {
        resolve({ status: status, result: result, headers: response.headers });
      });
    });
  }).then(function (_ref) {
    var status = _ref.status,
        result = _ref.result,
        headers = _ref.headers;

    return getResult(url, status, result, undefined, undefined, headers);
  }).catch(function (e) {
    return getError(url, e);
  });
};

exports.default = apiFetch;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/FetchService.js
// module id = 812
// module chunks = 10